import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface GiftCardsReducer {
    categories: any[] | null;
    generalGiftCards: any[] | null;
}

const initialState: GiftCardsReducer = {
    categories: null,
    generalGiftCards: null,
};

const giftCardsReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.GIFT_CARDS.CATEGORY_LIST:
            return {
                ...state,
                categories: action.payload,
            };

        case ACTIONS.GIFT_CARDS.GENERAL_GIFT_CARD_SEARCH:
            return {
                ...state,
                generalGiftCards: action.payload,
            };

        default:
            return state;
    }
};

export default giftCardsReducer;
